var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Footer"},[_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"copyright"},[_vm._v(" Visos teisės saugomos "+_vm._s(new Date().getFullYear())+" © SaulesBendruomene.lt ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }